import React from 'react';
import classNames from 'classnames';

import './HeaderDescription.scss';

export const HeaderDescription = ({ description, small = false, secondary = false }) => {
  return (
    <p styleName={classNames({
      'header-description': !small,
      'header-description--small': small,
      'header-description--secondary': secondary
    })}>{description}</p>
  );
};
